import type { ComponentType } from 'react'
import React from 'react'
import { withDependencies } from '@wix/thunderbolt-ioc'
import type { CompProps, Experiments } from '@wix/thunderbolt-symbols'
import { ExperimentsSymbol } from '@wix/thunderbolt-symbols'

const isCsr = !!process.env.browser

let useControllerHook: (
	displayedId: string,
	compType: string,
	_compProps: CompProps,
	compId: string
) => {
	[x: string]: any
}
;(async () => {
	isCsr && (await window.externalsRegistry.react.loaded)
	useControllerHook = require('./hooks').useControllerHook
})()
export const RunControllersWrapper = withDependencies([ExperimentsSymbol], (experiments: Experiments) => {
	const addIdAsClassName = experiments['specs.thunderbolt.addIdAsClassName']

	return {
		wrapComponent: (Component: ComponentType<any>) => {
			const Wrapper = ({
				compProps: storeProps,
				...restProps
			}: {
				compProps: any
				compId: string
				compClassType: string
				id: string
			}) => {
				const { id: displayedId, compId, compClassType } = restProps
				const compProps = useControllerHook(displayedId, compClassType, storeProps, compId)

				const props = {
					...compProps,
					...restProps,
				} as { [x: string]: any }

				const classNameId = addIdAsClassName ? displayedId : compId

				return <Component {...props} className={props?.className ? `${props.className} ${classNameId}` : classNameId} />
			}
			return Wrapper
		},
	}
})
